import React, { FC, ReactElement } from 'react';
import { AppBar, Toolbar, Typography, Grid, Divider, Box } from '@mui/material';
import useStyles from './styles';
import { uniqueId } from '../../globals/utils';

type HeaderProperties = {
  title: string;
  headerComponents: ReactElement[];
};

const Header: FC<HeaderProperties> = (properties: HeaderProperties) => {
  const classes = useStyles();
  const { title, headerComponents } = properties;

  return (
    <AppBar position="sticky" color="inherit" className={classes.appBar}>
      <Toolbar disableGutters>
        <Grid
          className={classes.container}
          container
          direction="row"
          justifyContent="space-between"
          alignItems="stretch"
        >
          <Typography className={classes.title}>{title}</Typography>
          <Grid item>
            <Grid
              className={classes.container}
              container
              justifyContent="space-between"
              alignItems="stretch"
            >
              {headerComponents.map((component: ReactElement) => (
                <Box display="flex" key={uniqueId()}>
                  <Grid className={classes.item} item>
                    {component}
                  </Grid>
                  <Divider orientation="vertical" />
                </Box>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export { Header };
export type { HeaderProperties };
